import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-center align-center",style:({
		width: `${_vm.size}px`,
		height: `${_vm.size}px`,
		borderRadius: '50%',
		backgroundColor: 'var(--amber-300)',
	})},[_c(VIcon,{style:({ fontSize: `${_vm.iconSize}px` }),attrs:{"fab":"","color":"var(--grey-900)"}},[_vm._v("mdi-crown")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }